<table class="timing-table table-auto w-full">
  <thead class="bg-surface-container text-on-surface-container text-xs sticky top-0 text-left">
    <tr>
      <th>P</th>
      <th class="text-center">#</th>
      <th>CAR</th>
      <th>TEAM/DRIVER</th>
      <th>PiC</th>
      <th>LAP</th>
      <th>GAP</th>
      <th>INTERVAL</th>
      <th>LAST LAP</th>
      <th>SECTOR 1</th>
      <th>SECTOR 2</th>
      <th>SECTOR 3</th>
      <th>BEST LAP</th>
      <th>PITS</th>
      <th>MAX SPEED</th>
    </tr>
  </thead>
  <tbody class="text-sm">
    <ng-container *ngFor="let team of teams(); trackBy: trackByFn">
      <tr
        class="hover:bg-surface-container-high"
        [ngClass]="timingTowerService.activeList().includes(team?.number) ? activeClass() : ''"
        [class.has-playback]="team?.playback?.url"
        [class.team-row-moved-up]="team?.positionChangeState === 'up'"
        [class.team-row-moved-down]="team?.positionChangeState === 'down'"
        (click)="toggleTeamSelection(team!)"
        (mouseenter)="showTooltip(team, $event)"
        (mouseleave)="hideTooltip()"
      >
        <td>
          <span
            [ngClass]="
              timingTowerService.activeList().includes(team?.number) ? activeNumberClass() : ''
            "
            >{{ team?.activeStanding?.position }}</span
          >
        </td>
        <td>
          <div
            class="rounded-sm flex items-center justify-center"
            [title]="team?.class"
            [style.background-color]="team?.classDetails?.background"
            [style.color]="team?.classDetails?.foreground"
          >
            <span>{{ team?.number }}</span>
          </div>
        </td>
        <td>
          <img
            class="w-6 h-6 object-contain"
            [src]="team?.manufacturer || team?.vehicle || '' | teamLogoLookup: team?.class"
            alt="Logo"
            [title]="team?.manufacturer || team?.vehicle"
          />
        </td>
        <td>
          <span class="flex">
            {{ team?.currentDriverFullName }}
          </span>
          <div style="font-size: 10px">
            <div>{{ team?.team }}</div>
          </div>
        </td>
        <td>{{ team?.classStanding?.position }}</td>
        <td>{{ team?.participantDetails?.currentLap }}</td>
        <td class="timing-data-bold">
          @if (team?.activeStanding?.gapFirstLaps > 0) {
            {{ team?.activeStanding?.gapFirstLaps }}L
          } @else {
            +{{
              team?.activeStanding?.gapFirstTime
                ? (team?.activeStanding?.gapFirstTime || 0 | timespanShort)
                : '0.000'
            }}
          }
        </td>
        <td class="timing-data-bold">
          @if (team?.activeStanding?.gapPreviousLaps > 0) {
            {{ team?.activeStanding?.gapPreviousLaps }}L
          } @else {
            +{{
              team?.activeStanding?.gapPreviousTime
                ? (team?.activeStanding?.gapPreviousTime || 0 | timespanShort)
                : '0.000'
            }}
          }
        </td>
        <td class="timing-data-bold">{{ team?.participantDetails?.lastLap?.time | timespanMs }}</td>
        <td class="timing-data-bold">
          @if (team?.currentLapSectorData[1]) {
            <span [ngClass]="team?.currentLapSectorData[1].className">
              {{ team?.currentLapSectorData[1].time | timespanShort }}
            </span>
          } @else {
            <span>--</span>
          }
        </td>
        <td class="timing-data-bold">
          @if (team?.currentLapSectorData[2]) {
            <span [ngClass]="team?.currentLapSectorData[2].className">
              {{ team?.currentLapSectorData[2].time | timespanShort }}
            </span>
          } @else {
            <span>--</span>
          }
        </td>
        <td class="timing-data-bold">
          @if (team?.currentLapSectorData[3]) {
            <span [ngClass]="team?.currentLapSectorData[3].className">
              {{ team?.currentLapSectorData[3].time | timespanShort }}
            </span>
          } @else {
            <span>--</span>
          }
        </td>
        <td class="timing-data-bold">{{ team?.participantDetails?.bestLap?.time | timespanMs }}</td>
        <td>{{ team.participantDetails?.pitStops }}</td>
        <td [class.text-secondary]="team.isTopSpeedOverall">
          {{ team.participantDetails.bestTopSpeed | number: '1.1-1' }}
        </td>
      </tr>
    </ng-container>
  </tbody>
</table>

@if (hoveredTeam()) {
  <vb-lxp-tooltip
    [team]="hoveredTeam()"
    [style.top.px]="tooltipTop()"
    [style.left.px]="tooltipLeft()"
  ></vb-lxp-tooltip>
}
